import { PhotoList } from './view';
export default PhotoList;
